import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { ReactElement } from 'react'

/**
 * `/admin/finance/reference-accounts/$templateId` — pathless layout for
 * this template's detail page (index) and its `edit` / `accounts/*` leaf
 * routes. Mirrors `admin.finance.tsx`'s layout/index/leaf-route split —
 * without this Outlet, the sibling routes match but never render, since
 * TanStack Router nests any file sharing this prefix underneath it.
 */
export const Route = createFileRoute(
  '/admin/finance/reference-accounts/$templateId',
)({
  component: TemplateLayout,
})

function TemplateLayout(): ReactElement {
  return <Outlet />
}
